module.exports = __webpack_public_path__ + "static/media/Rectangle 110.f81b9344.png";